
/*
 * Licensed Materials - Property of IBM
 * IBM Business Analytics (C) Copyright IBM Corp. 2019, 2021
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

/**
 * @interface PropertiesProviderAPI
 * @hideconstructor
 * @classdesc API class that is used to implement a properties provider for contributing a list of properties and property layouts.
 */
define([], () => {
	class PropertiesProviderAPI {

		/**
		 * @function PropertiesProviderAPI#getPropertyLayoutList
		 * @description Gets the list of properties layout.
		 * @return {Object[]}
		 */
		getPropertyLayoutList() {}

		/**
		 * @function PropertiesProviderAPI#getPropertyList
		 * @description Gets the list of properties.
		 * @return {Object[]}
		 */
		getPropertyList() {}

	}

	return PropertiesProviderAPI;
});
